import { render, staticRenderFns } from "./UploadImages.vue?vue&type=template&id=074d98c2&lang=html&"
import script from "./UploadImages.vue?vue&type=script&lang=js&"
export * from "./UploadImages.vue?vue&type=script&lang=js&"
import style0 from "./UploadImages.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports